// providers/Providers.tsx
"use client";
import { useEffect, useState } from "react";
import QueryClientProvider from "./QueryClientProvider";
import ChakraProvider from "./ChakraProvider";
import AppContextProvider from "./AppContextProvider";
import { Helmet } from "react-helmet";
import { ScrollToTop, PageTracker } from "components";

export default function Providers({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <QueryClientProvider>
      <ChakraProvider>
        <AppContextProvider>
          <Helmet>
            <title>DeepMode.com - Create your own AI clone model</title>
          </Helmet>
          {mounted ? <ScrollToTop /> : null}
          <PageTracker>{children}</PageTracker>
        </AppContextProvider>
      </ChakraProvider>
    </QueryClientProvider>
  );
}